/*
 * ═══════════════════════════════════════════════════════════════════════
 *  AC SIZING ENGINE — Data Layer
 *  ISHRAE Handbook 2017 + BEE 2026 + State Electricity Tariffs
 * ═══════════════════════════════════════════════════════════════════════
 */

// ─── CITY DATABASE ──────────────────────────────────────────────────
// Source: ISHRAE HVAC Databook Table 16.1.1 (0.4% design conditions)
// + state electricity tariffs from DISCOM official data 2025-26
// db: design dry-bulb °C, wb: coincident wet-bulb °C
// gr: humidity ratio grains/lb (derived from wb)
// zone: HD=Hot-Dry, WH=Warm-Humid, CO=Composite, TE=Temperate
// mo: cooling season months, rate: effective ₹/kWh for 300-500u household
// dr: daily range °C
export const CITIES = {
  nagpur:        { name:"Nagpur",          state:"Maharashtra", db:43.8, wb:23.6, gr:72, zone:"CO", mo:8,  rate:14.0, dr:14, lat:21.15, elev:310 },
  chandigarh:    { name:"Chandigarh",      state:"Chandigarh",  db:43.0, wb:24.0, gr:74, zone:"CO", mo:8,  rate:6.5,  dr:14, lat:30.73, elev:321 },
  jaipur:        { name:"Jaipur",          state:"Rajasthan",   db:42.8, wb:22.5, gr:65, zone:"HD", mo:8,  rate:8.5,  dr:15, lat:26.92, elev:431 },
  ahmedabad:     { name:"Ahmedabad",       state:"Gujarat",     db:42.3, wb:24.1, gr:75, zone:"HD", mo:8,  rate:5.1,  dr:14, lat:23.03, elev:55 },
  lucknow:       { name:"Lucknow",         state:"UP",          db:42.0, wb:24.2, gr:76, zone:"CO", mo:8,  rate:9.7,  dr:13, lat:26.85, elev:123 },
  delhi:         { name:"Delhi NCR",       state:"Delhi",       db:41.8, wb:23.6, gr:72, zone:"CO", mo:8,  rate:5.2,  dr:13, lat:28.61, elev:216 },
  jodhpur:       { name:"Jodhpur",         state:"Rajasthan",   db:42.7, wb:22.0, gr:62, zone:"HD", mo:8,  rate:8.5,  dr:16, lat:26.28, elev:224 },
  bhopal:        { name:"Bhopal",          state:"MP",          db:41.7, wb:22.0, gr:62, zone:"CO", mo:8,  rate:8.3,  dr:14, lat:23.26, elev:495 },
  varanasi:      { name:"Varanasi",        state:"UP",          db:41.9, wb:25.7, gr:85, zone:"CO", mo:8,  rate:9.7,  dr:12, lat:25.32, elev:85 },
  indore:        { name:"Indore",          state:"MP",          db:41.1, wb:20.7, gr:55, zone:"CO", mo:7,  rate:8.3,  dr:15, lat:22.72, elev:549 },
  allahabad:     { name:"Prayagraj",       state:"UP",          db:43.2, wb:24.1, gr:75, zone:"CO", mo:8,  rate:9.7,  dr:14, lat:25.43, elev:98 },
  patna:         { name:"Patna",           state:"Bihar",       db:40.7, wb:23.4, gr:70, zone:"CO", mo:8,  rate:7.5,  dr:11, lat:25.61, elev:53 },
  hyderabad:     { name:"Hyderabad",       state:"Telangana",   db:40.4, wb:22.5, gr:65, zone:"CO", mo:8,  rate:7.5,  dr:11, lat:17.39, elev:505 },
  gwalior:       { name:"Gwalior",         state:"MP",          db:43.6, wb:23.4, gr:70, zone:"CO", mo:8,  rate:8.3,  dr:14, lat:26.22, elev:207 },
  amritsar:      { name:"Amritsar",        state:"Punjab",      db:41.8, wb:23.9, gr:74, zone:"CO", mo:8,  rate:7.5,  dr:14, lat:31.63, elev:234 },
  dehradun:      { name:"Dehradun",        state:"Uttarakhand", db:36.4, wb:24.2, gr:76, zone:"CO", mo:6,  rate:6.0,  dr:12, lat:30.32, elev:682 },
  raipur:        { name:"Raipur",          state:"Chhattisgarh",db:43.2, wb:22.9, gr:67, zone:"CO", mo:8,  rate:6.5,  dr:14, lat:21.25, elev:298 },
  ranchi:        { name:"Ranchi",          state:"Jharkhand",   db:39.0, wb:23.2, gr:69, zone:"CO", mo:7,  rate:7.0,  dr:13, lat:23.34, elev:655 },
  noida:         { name:"Noida",           state:"UP",          db:41.8, wb:23.6, gr:72, zone:"CO", mo:8,  rate:9.7,  dr:13, lat:28.53, elev:200 },
  gurgaon:       { name:"Gurugram",        state:"Haryana",     db:41.8, wb:23.6, gr:72, zone:"CO", mo:8,  rate:5.5,  dr:13, lat:28.46, elev:217 },
  faridabad:     { name:"Faridabad",       state:"Haryana",     db:41.8, wb:23.6, gr:72, zone:"CO", mo:8,  rate:5.5,  dr:13, lat:28.41, elev:198 },
  ghaziabad:     { name:"Ghaziabad",       state:"UP",          db:41.8, wb:23.6, gr:72, zone:"CO", mo:8,  rate:9.7,  dr:13, lat:28.67, elev:210 },
  // Warm-Humid
  chennai:       { name:"Chennai",         state:"Tamil Nadu",  db:38.4, wb:26.2, gr:96, zone:"WH", mo:12, rate:5.7,  dr:8,  lat:13.08, elev:7 },
  mumbai:        { name:"Mumbai",          state:"Maharashtra", db:35.3, wb:22.8, gr:67, zone:"WH", mo:10, rate:9.0,  dr:6,  lat:19.08, elev:14 },
  kolkata:       { name:"Kolkata",         state:"West Bengal", db:37.2, wb:25.4, gr:86, zone:"WH", mo:9,  rate:6.6,  dr:8,  lat:22.57, elev:9 },
  visakhapatnam: { name:"Visakhapatnam",   state:"AP",          db:36.4, wb:26.5, gr:98, zone:"WH", mo:9,  rate:5.9,  dr:7,  lat:17.69, elev:3 },
  kochi:         { name:"Kochi",           state:"Kerala",      db:34.5, wb:26.5, gr:98, zone:"WH", mo:12, rate:8.5,  dr:6,  lat:9.93,  elev:3 },
  guwahati:      { name:"Guwahati",        state:"Assam",       db:34.4, wb:26.9, gr:101,zone:"WH", mo:8,  rate:6.5,  dr:9,  lat:26.14, elev:55 },
  surat:         { name:"Surat",           state:"Gujarat",     db:38.4, wb:22.7, gr:66, zone:"WH", mo:10, rate:5.1,  dr:10, lat:21.17, elev:13 },
  mangalore:     { name:"Mangalore",       state:"Karnataka",   db:34.6, wb:24.1, gr:75, zone:"WH", mo:10, rate:8.5,  dr:8,  lat:12.87, elev:22 },
  thiruvananthapuram: { name:"Trivandrum",  state:"Kerala",      db:33.2, wb:27.4, gr:105,zone:"WH", mo:12, rate:8.5,  dr:6, lat:8.52, elev:64 },
  nellore:       { name:"Nellore",         state:"AP",          db:40.3, wb:26.9, gr:101,zone:"WH", mo:10, rate:5.9,  dr:9,  lat:14.44, elev:20 },
  tiruchirappalli:{ name:"Trichy",         state:"Tamil Nadu",  db:38.4, wb:25.8, gr:88, zone:"WH", mo:11, rate:5.7,  dr:10, lat:10.79, elev:88 },
  // Temperate
  bangalore:     { name:"Bangalore",       state:"Karnataka",   db:34.7, wb:19.6, gr:50, zone:"TE", mo:4,  rate:8.5,  dr:11, lat:12.97, elev:920 },
  pune:          { name:"Pune",            state:"Maharashtra", db:38.4, wb:20.5, gr:53, zone:"TE", mo:6,  rate:14.0, dr:13, lat:18.52, elev:560 },
  coimbatore:    { name:"Coimbatore",      state:"Tamil Nadu",  db:37.5, wb:23.0, gr:68, zone:"TE", mo:6,  rate:5.7,  dr:11, lat:11.00, elev:411 },
  mysore:        { name:"Mysuru",          state:"Karnataka",   db:35.5, wb:20.0, gr:51, zone:"TE", mo:5,  rate:8.5,  dr:12, lat:12.30, elev:770 },
  // Hot-Dry
  aurangabad:    { name:"Aurangabad",      state:"Maharashtra", db:40.4, wb:22.5, gr:65, zone:"HD", mo:7,  rate:14.0, dr:14, lat:19.88, elev:579 },
  rajkot:        { name:"Rajkot",          state:"Gujarat",     db:41.4, wb:21.9, gr:61, zone:"HD", mo:8,  rate:5.1,  dr:14, lat:22.30, elev:138 },
  vadodara:      { name:"Vadodara",        state:"Gujarat",     db:41.5, wb:23.5, gr:71, zone:"HD", mo:8,  rate:5.1,  dr:13, lat:22.31, elev:39 },
};

export const CITY_LIST = Object.entries(CITIES)
  .sort((a,b) => a[1].name.localeCompare(b[1].name))
  .map(([k,v]) => ({ key:k, ...v }));

// ─── INDOOR DESIGN ─────────────────────────────────────────────────
export const INDOOR = { db_f: 75, rh: 50, gr: 54 }; // 75°F = ~24°C

// ─── SOLAR HEAT GAIN FACTORS (BTU/h·sq.ft) — ASHRAE for ~26°N ─────
export const SHGF = { N:14, NE:12, E:75, SE:12, S:12, SW:100, W:164, NW:123 };

// ─── WALL CLTD (°F) ───────────────────────────────────────────────
export const CLTD_WALL = { N:14, NE:14, E:18, SE:18, S:26, SW:40, W:40, NW:24 };

// ─── U-VALUES ─────────────────────────────────────────────────────
export const UVAL = {
  glass_single: 1.0, glass_double: 0.55,
  wall_brick: 0.48, wall_rcc: 0.65, wall_insulated: 0.28,
  partition: 0.41, roof_rcc: 0.48, roof_insulated: 0.07,
  ceiling: 0.397, floor: 0.40,
};

// ─── SHADING COEFFICIENTS (SC) ────────────────────────────────────
export const SC = { glass_single: 0.95, glass_double: 0.80 };

// ─── PEOPLE HEAT ──────────────────────────────────────────────────
export const PEOPLE = {
  seated:  { s:245, l:205, label:"Seated / Office" },
  standing:{ s:295, l:455, label:"Standing / Light Work" },
  walking: { s:345, l:545, label:"Walking / Retail" },
  dining:  { s:275, l:425, label:"Dining" },
  heavy:   { s:545, l:870, label:"Heavy Work / Gym" },
};

// ─── SPACE TYPE PRESETS ───────────────────────────────────────────
// Each preset auto-fills: people count, activity, lighting W/sqft,
// equipment kW, ventilation ACH, bypass factor
export const SPACE_PRESETS = {
  bedroom:    { label:"Bedroom",          icon:"🛏️", people:2,  activity:"seated",   lightW:0.5, eqKW:0.3,  ach:1.0, bf:0.12, cfmPP:10, wallType:"brick", glassType:"single", glassPct:0.12 },
  living:     { label:"Living Room",      icon:"🛋️", people:4,  activity:"seated",   lightW:0.8, eqKW:0.8,  ach:1.5, bf:0.15, cfmPP:10, wallType:"brick", glassType:"single", glassPct:0.15 },
  study:      { label:"Study / Office",   icon:"💻", people:2,  activity:"seated",   lightW:1.0, eqKW:1.5,  ach:1.5, bf:0.15, cfmPP:15, wallType:"brick", glassType:"single", glassPct:0.12 },
  kitchen:    { label:"Kitchen",          icon:"🍳", people:2,  activity:"standing", lightW:1.2, eqKW:5.0,  ach:2.0, bf:0.15, cfmPP:15, wallType:"brick", glassType:"single", glassPct:0.08 },
  office:     { label:"Commercial Office",icon:"🏢", people:6,  activity:"seated",   lightW:1.2, eqKW:3.0,  ach:1.5, bf:0.15, cfmPP:15, wallType:"brick", glassType:"double", glassPct:0.20 },
  shop:       { label:"Retail Shop",      icon:"🏪", people:8,  activity:"walking",  lightW:1.5, eqKW:1.5,  ach:2.0, bf:0.15, cfmPP:15, wallType:"brick", glassType:"single", glassPct:0.25 },
  restaurant: { label:"Restaurant",       icon:"🍽️", people:20, activity:"dining",   lightW:1.2, eqKW:5.0,  ach:2.5, bf:0.18, cfmPP:15, wallType:"brick", glassType:"single", glassPct:0.15 },
  server:     { label:"Server Room",      icon:"🖥️", people:1,  activity:"seated",   lightW:1.0, eqKW:8.0,  ach:1.0, bf:0.10, cfmPP:15, wallType:"insulated", glassType:"double", glassPct:0.05 },
};

// ─── DIRECTIONS ───────────────────────────────────────────────────
export const DIRS = ["N","NE","E","SE","S","SW","W","NW"];

// ─── CONSTANTS ────────────────────────────────────────────────────
export const KW_PER_TON = 3.517;

// ═══════════════════════════════════════════════════════════════════
//  ISHRAE HEAT LOAD CALCULATION ENGINE
// ═══════════════════════════════════════════════════════════════════
//
//  This mirrors your SUN STAR / LAB ROOM sheet exactly:
//  RSH → +duct% +safety% +OA_sen_BF → ERSH
//  RLH → +latSafety% +OA_lat_BF → ERLH
//  ERTH = ERSH + ERLH
//  + OA_sen_coil + OA_lat_coil → SubTotal
//  + returnDuct% → GRAND TOTAL → TR
//
// ═══════════════════════════════════════════════════════════════════
//  ISHRAE HEAT LOAD CALCULATION ENGINE
// ═══════════════════════════════════════════════════════════════════
export function ishrae(p) {
  const { area, height, glassU, roofType, indoorF, cityElev, glassType } = p;
  const volume = area * height;
  const dT = p.cityDB_F - indoorF;
  const dGr = p.cityGr - INDOOR.gr;
  const BF = p.bf;
  const ppl = PEOPLE[p.activity];

  // Elevation Density Ratio (fixes high altitude CFM mass)
  const densityRatio = cityElev ? Math.exp(-cityElev / 8400) : 1;
  const senConst = 1.08 * densityRatio;
  const latConst = 0.68 * densityRatio;

  // 1. SOLAR GAIN GLASS = Σ(area × SHGF × SC) -- FIXED
  let solarGlass = 0;
  const sgDetail = {};
  const sc = SC[`glass_${glassType}`] || 0.95; 
  DIRS.forEach(d => {
    const ga = p.glassAreas?.[d] || 0;
    const g = Math.round(ga * SHGF[d] * sc); 
    sgDetail[d] = { area: ga, shgf: SHGF[d], gain: g };
    solarGlass += g;
  });

  // 2. WALL TRANSMISSION = Σ(area × CLTD × U)
  let wallTrans = 0;
  const wDetail = {};
  DIRS.forEach(d => {
    const wa = p.wallAreas?.[d] || 0;
    const wu = p.wallUs?.[d] || 0;
    const g = Math.round(wa * CLTD_WALL[d] * wu);
    wDetail[d] = { area: wa, cltd: CLTD_WALL[d], u: wu, gain: g };
    wallTrans += g;
  });

  // 3. ROOF -- FIXED (Both use 45 CLTD, U-value dictates heat drop)
  let roofGain = 0;
  if (roofType === "rcc") roofGain = Math.round(area * 45 * UVAL.roof_rcc);
  else if (roofType === "insulated") roofGain = Math.round(area * 45 * UVAL.roof_insulated);

  // 4. GLASS CONDUCTION
  let totalGlassArea = 0;
  DIRS.forEach(d => totalGlassArea += (p.glassAreas?.[d] || 0));
  const glassCond = Math.round(totalGlassArea * dT * glassU);

  // 5. PARTITION (Internal Walls + Unconditioned Ceiling/Floor)
  const partGainWall = Math.round((p.partArea || 0) * (p.partDT || 0) * UVAL.partition);
  
  let partGainCeiling = 0;
  let partGainFloor = 0;
  
  // Neighboring unconditioned apartments run hot (approx Outdoor Temp - 5°F)
  const verticalDT = Math.max(0, (p.cityDB_F - 5) - p.indoorF); 

  // If mid or ground floor, heat bleeds down from the unconditioned room above
  if (p.floorLevel === "mid" || p.floorLevel === "ground") {
      partGainCeiling = Math.round(area * verticalDT * UVAL.ceiling);
  }
  // If mid or top floor, heat bleeds up from the unconditioned room below
  if (p.floorLevel === "mid" || p.floorLevel === "top") {
      partGainFloor = Math.round(area * (verticalDT - 5) * UVAL.floor); 
  }
  
  const partGain = partGainWall + partGainCeiling + partGainFloor;

  // 6-8. INTERNAL
  const peopleSen = Math.round(p.numPeople * ppl.s);
  const peopleLat = Math.round(p.numPeople * ppl.l);
  const lightGain = Math.round(area * p.lightW * 1.25 * 3.41);
  const equipGain = Math.round(p.eqKW * 1000 * 3.41);

  // 9. RSH
  const RSH = solarGlass + wallTrans + roofGain + glassCond + partGain + peopleSen + lightGain + equipGain;

  // 10-11. Duct + Safety
  const ductGain = Math.round(RSH * p.ductPct / 100);
  const safetyGain = Math.round(RSH * p.safPct / 100);

  // 12. Ventilation CFM
  const cfmPeople = Math.round(p.numPeople * p.cfmPP);
  const cfmACH = Math.round(volume * p.ach / 60);
  const CFM = Math.max(cfmPeople, cfmACH);

  // 13. OA Sensible (BF portion) -- FIXED density
  const oaSenBF = Math.round(CFM * dT * BF * senConst);

  // 14. ERSH
  const ERSH = RSH + ductGain + safetyGain + oaSenBF;

  // 15-17. Latent
  const RLH = peopleLat;
  const latSaf = Math.round(RLH * p.latSafPct / 100);
  const oaLatBF = Math.round(CFM * dGr * BF * latConst);
  const ERLH = RLH + latSaf + oaLatBF;

  // 18. ERTH
  const ERTH = ERSH + ERLH;

  // 19-20. OA Coil (1-BF) -- FIXED density
  const oaSenCoil = Math.round(CFM * dT * (1 - BF) * senConst);
  const oaLatCoil = Math.round(CFM * dGr * (1 - BF) * latConst);

  // 21-22. Sub + Return
  const sub = ERTH + oaSenCoil + oaLatCoil;
  const retGain = Math.round(sub * p.retPct / 100);

  // 23-24. GRAND TOTAL + TR
  const GT = sub + retGain;
  const TR = +(GT / 12000).toFixed(2);

  const ESHF = ERTH > 0 ? +(ERSH / ERTH).toFixed(2) : 0;

  return {
    area, volume, dT, dGr,
    sgDetail, solarGlass,
    wDetail, wallTrans,
    roofGain, totalGlassArea, glassCond, partGain,
    peopleSen, peopleLat, lightGain, equipGain,
    RSH, ductGain, safetyGain,
    cfmPeople, cfmACH, CFM,
    oaSenBF, ERSH,
    RLH, latSaf, oaLatBF, ERLH, ERTH,
    oaSenCoil, oaLatCoil,
    sub, retGain, GT, TR, ESHF,
    btuSqft: area > 0 ? +(GT / area).toFixed(1) : 0,
    sqftTR: TR > 0 ? Math.round(area / TR) : 0,
  };
}

// ═══════════════════════════════════════════════════════════════════
//  SMART DEFAULTS: Build ISHRAE inputs from basic selections
// ═══════════════════════════════════════════════════════════════════
// ═══════════════════════════════════════════════════════════════════
//  SMART DEFAULTS: Build ISHRAE inputs from basic selections
// ═══════════════════════════════════════════════════════════════════
export function buildInputs({ cityKey, spaceKey, area, floorLevel, windowDir, height, targetTempC, overrides }) {
  const city = CITIES[cityKey];
  const sp = SPACE_PRESETS[spaceKey];
  const ht = overrides?.height || height || 10;
  const indoorF = overrides?.indoorF || Math.round(targetTempC * 9/5 + 32);
  const glassU = overrides?.glassU || UVAL[`glass_${sp.glassType}`];
  const wallU = UVAL[`wall_${sp.wallType}`];
  const glassType = overrides?.glassType || sp.glassType;

  // Auto-estimate wall & glass areas from room dimensions
  const side = Math.sqrt(area);
  const oneWallArea = side * ht; // Area of a single wall
  const glassPerWall = Math.round(oneWallArea * sp.glassPct);

  // Build directional arrays
  const glassAreas = {};
  const wallAreas = {};
  const wallUs = {};
  DIRS.forEach(d => {
    glassAreas[d] = 0;
    wallAreas[d] = 0;
    wallUs[d] = 0;
  });

  // Apply window direction — main window gets full glass estimate
  if (windowDir && windowDir !== "none") {
    glassAreas[windowDir] = overrides?.glassArea || glassPerWall;
    wallAreas[windowDir] = Math.max(0, oneWallArea - glassAreas[windowDir]);
    wallUs[windowDir] = overrides?.wallU || wallU;
  }

  const numExternalWalls = overrides?.numExternalWalls || (floorLevel === "top" ? 2 : 1);
  if (numExternalWalls >= 2 && windowDir !== "none") {
    const perpDirs = { N:"E", NE:"E", E:"S", SE:"S", S:"W", SW:"W", W:"N", NW:"N" };
    const perpDir = perpDirs[windowDir] || "E";
    if (!wallUs[perpDir]) {
      wallAreas[perpDir] = oneWallArea;
      wallUs[perpDir] = overrides?.wallU || wallU;
    }
  }

  // FIXED BUG: Calculate the remaining internal walls.
  // Assume standard rooms have 4 walls. Subtract the external walls to find internal walls.
  // We assume roughly 60% of internal walls touch unconditioned/hot spaces (hallways, outside facing kitchens)
  const totalInternalWallArea = (4 - numExternalWalls) * oneWallArea;
  const autoPartitionArea = Math.round(totalInternalWallArea * 0.60); 

  // Allow full override of wall/glass arrays
  if (overrides?.glassAreas) Object.assign(glassAreas, overrides.glassAreas);
  if (overrides?.wallAreas) Object.assign(wallAreas, overrides.wallAreas);
  if (overrides?.wallUs) Object.assign(wallUs, overrides.wallUs);

  // Inside buildInputs(), near the very bottom:
  return {
    area,
    height: ht,
    cityDB_F: Math.round(city.db * 9/5 + 32),
    cityGr: city.gr,
    cityElev: city.elev, 
    floorLevel,          // <--- ADD THIS LINE HERE
    glassType,           
    glassU,
    glassAreas,
    wallAreas,
    wallUs,
    roofType: floorLevel === "top" ? (overrides?.roofType || "rcc") : "none",
    
    // FIXED BUG: Inject the auto-calculated partition area if user hasn't overridden it
    partArea: overrides?.partArea ?? autoPartitionArea, 
    partDT: overrides?.partDT || 15, 
    
    numPeople: overrides?.numPeople || sp.people,
    
    activity: overrides?.activity || sp.activity,
    lightW: overrides?.lightW ?? sp.lightW,
    eqKW: overrides?.eqKW ?? sp.eqKW,
    cfmPP: overrides?.cfmPP || sp.cfmPP,
    ach: overrides?.ach || sp.ach,
    bf: overrides?.bf || sp.bf,
    ductPct: overrides?.ductPct ?? 4,
    safPct: overrides?.safPct ?? 10,
    latSafPct: overrides?.latSafPct ?? 5,
    retPct: overrides?.retPct ?? 5,
    indoorF,
  };
}

// ═══════════════════════════════════════════════════════════════════
//  DYNAMIC TONNAGE SELECTION
// ═══════════════════════════════════════════════════════════════════
export function selectTonnage(tr) {
  // Allow a tiny 5% tolerance (e.g., a 1.05 TR load can safely be handled by a 1.0 Ton AC)
  const adjustedTR = tr * 0.95; 

  // 1. Dynamically find all unique tonnages currently sitting in your PRODUCTS array
  const availableTonnages = [...new Set(PRODUCTS.map(p => p.ton))].sort((a, b) => a - b);
  
  // 2. Find the first available size that is greater than or equal to the adjusted load
  const recommendedTon = availableTonnages.find(t => t >= adjustedTR);

  if (!recommendedTon) {
    if (tr <= 3.50) return { ton: null, note: "Consider Daikin Cassette or 2× Split units" };
    return { ton: null, note: "Requires VRV / Ductable system — contact us for design" };
  }

  return { ton: recommendedTon, note: "" };
}

// ═══════════════════════════════════════════════════════════════════
//  ISEER ENERGY COST (BEE Formula)
//  Annual kWh = (Capacity_kW × Usage_Hours) / effective_ISEER
// ═══════════════════════════════════════════════════════════════════
// ═══════════════════════════════════════════════════════════════════
//  ISEER ENERGY COST (BEE Formula)
// ═══════════════════════════════════════════════════════════════════
export function calcEnergy({ ton, iseer, type, dailyHrs, coolingMonths, elecRate, targetTempC, topFloor, highSun, poorInsul }) {
  let effectiveISEER = iseer;
  const fullLoadISEER = 3.6; // Correctly scoped outside the IF block

  if (type === "inverter") {
    let penalty = 0;
    if (targetTempC <= 20) penalty += 1.0;
    else if (targetTempC <= 22) penalty += 0.5;
    else if (targetTempC === 23) penalty += 0.2;
    
    if (topFloor) penalty += 0.35;
    if (poorInsul) penalty += 0.40;
    if (highSun) penalty += 0.20;
    
    penalty = Math.min(1.0, penalty);
    effectiveISEER = iseer - (penalty * (iseer - fullLoadISEER));
  }

  const capacityKW = ton * KW_PER_TON;
  const totalHrs = dailyHrs * 30 * coolingMonths;
  
  // FIXED: Added 60% load factor (Duty Cycle)
  const loadFactor = 0.60; 
  const kwh = Math.round((capacityKW * totalHrs * loadFactor) / effectiveISEER);
  
  const yearly = Math.round(kwh * elecRate);
  const monthly = Math.round(yearly / coolingMonths);

  return {
    kwh, yearly, monthly, effectiveISEER: +effectiveISEER.toFixed(2),
    isHeatTrap: (topFloor && poorInsul) || (effectiveISEER < fullLoadISEER + 0.5 && type === "inverter"),
  };
}

// ═══════════════════════════════════════════════════════════════════
//  GENERIC PRODUCT TIERS (CarDekho-style)
//  These are tier templates — specific products are listed under each
// ═══════════════════════════════════════════════════════════════════
export const TIERS = {
  premium: {
    label: "Premium Inverter",
    sublabel: "5-Star (BEE 2026)",
    badge: "⭐ Best Efficiency",
    color: "#059669",
    iseerRange: "5.60–6.60",
    desc: "Highest ISEER, lowest bills, quietest operation. 10yr compressor warranty.",
  },
  standard: {
    label: "Standard Inverter",
    sublabel: "3–4 Star",
    badge: "💰 Best Value",
    color: "#2563eb",
    iseerRange: "4.00–5.59",
    desc: "Good efficiency at a lower price point. 10yr compressor warranty.",
  },
  fixed: {
    label: "Fixed Speed",
    sublabel: "Non-Inverter",
    badge: "🔌 Budget",
    color: "#d97706",
    iseerRange: "3.30–3.50",
    desc: "Lowest upfront cost. Best for occasional/light usage. 5yr compressor warranty.",
  },
};

// ─── DAIKIN PRODUCT DATABASE (starting point — user will provide full data) ──
export const PRODUCTS = [
  // Premium Inverter (BEE 2026 5-star, ISEER ≥ 5.60)
  { id:"FTKF35XV", brand:"Daikin", name:"FTKF35XV Highest ISEER", tier:"premium", ton:1.0, iseer:6.60, price:54000, noise:28, ambient:55, star:5, compW:10, features:["3D Airflow","Coanda","PM2.5","DNNS Self-Heal"] },
  { id:"FTKF50XV", brand:"Daikin", name:"FTKF50XV Highest ISEER", tier:"premium", ton:1.5, iseer:6.30, price:72000, noise:30, ambient:55, star:5, compW:10, features:["3D Airflow","Coanda","PM2.5","DNNS Self-Heal"] },
  { id:"FTKF60XV", brand:"Daikin", name:"FTKF60XV Highest ISEER", tier:"premium", ton:1.8, iseer:6.00, price:89000, noise:32, ambient:55, star:5, compW:10, features:["3D Airflow","Coanda","PM2.5","DNNS Self-Heal"] },
  { id:"FTKM50XV", brand:"Daikin", name:"FTKM50XV Premium",      tier:"premium", ton:1.5, iseer:5.70, price:45800, noise:30, ambient:55, star:5, compW:10, features:["Dew Clean","Triple Display","PM2.5"] },
  { id:"FTKU50XV", brand:"Daikin", name:"FTKU50XV Standard 5★",   tier:"premium", ton:1.5, iseer:5.70, price:52000, noise:30, ambient:55, star:5, compW:10, features:["Dew Clean","Hepta Sense"] },
  { id:"FTKR50XV", brand:"Daikin", name:"FTKR50XV Smart Wi-Fi",   tier:"premium", ton:1.5, iseer:5.70, price:56000, noise:30, ambient:55, star:5, compW:10, features:["Wi-Fi","Voice Control","Smart Diag"] },
  // Standard Inverter (3-4 star, ISEER 4.0-5.59)
  { id:"MTKM50U",  brand:"Daikin", name:"MTKM50U Premium",       tier:"standard", ton:1.5, iseer:5.20, price:42500, noise:30, ambient:52, star:4, compW:10, features:["PM2.5","Triple Display","Econo"] },
  { id:"FTKL50XV", brand:"Daikin", name:"FTKL50XV 3-Star",       tier:"standard", ton:1.5, iseer:4.40, price:37000, noise:33, ambient:52, star:3, compW:10, features:["PM2.5","Econo","DNNS"] },
  { id:"ATKL50U",  brand:"Daikin", name:"ATKL50U Value",         tier:"standard", ton:1.5, iseer:4.00, price:33500, noise:34, ambient:52, star:3, compW:10, features:["Econo","DNNS","Self Diagnosis"] },
  { id:"MTKM35U",  brand:"Daikin", name:"MTKM35U Premium",       tier:"standard", ton:1.0, iseer:5.20, price:35500, noise:30, ambient:52, star:4, compW:10, features:["PM2.5","Triple Display","Econo"] },
  { id:"FTKL35XV", brand:"Daikin", name:"FTKL35XV 3-Star",       tier:"standard", ton:1.0, iseer:4.40, price:31300, noise:32, ambient:52, star:3, compW:10, features:["PM2.5","Econo","DNNS"] },
  { id:"MTKL60U",  brand:"Daikin", name:"MTKL60U 3-Star",        tier:"standard", ton:1.8, iseer:4.00, price:48000, noise:34, ambient:52, star:3, compW:10, features:["PM2.5","Econo"] },
  { id:"FTKL71XV", brand:"Daikin", name:"FTKL71XV 3-Star",       tier:"standard", ton:2.0, iseer:4.40, price:56700, noise:35, ambient:52, star:3, compW:10, features:["PM2.5","Power Chill"] },
  // Fixed Speed (Non-Inverter)
  { id:"FTL35U",   brand:"Daikin", name:"FTL35U Fixed Speed",    tier:"fixed", ton:1.0, iseer:3.35, price:30000, noise:37, ambient:50, star:3, compW:5, features:["PM2.5","Power Chill","DNNS"] },
  { id:"FTL50U",   brand:"Daikin", name:"FTL50U Fixed Speed",    tier:"fixed", ton:1.5, iseer:3.35, price:33000, noise:38, ambient:50, star:3, compW:5, features:["PM2.5","Power Chill","DNNS"] },
  { id:"FTL60U",   brand:"Daikin", name:"FTL60U Fixed Speed",    tier:"fixed", ton:1.8, iseer:3.30, price:38000, noise:39, ambient:50, star:3, compW:5, features:["PM2.5","Power Chill"] },
  { id:"FTQ50U",   brand:"Daikin", name:"FTQ50U Fixed Speed",    tier:"fixed", ton:1.5, iseer:3.30, price:37000, noise:39, ambient:50, star:2, compW:5, features:["DNNS","Auto Restart"] },
];

// ─── Helper: get products for a tonnage ───────────────────────────
export function getProducts(ton) {
  return {
    premium:  PRODUCTS.filter(p => p.tier === "premium"  && p.ton === ton).sort((a,b) => b.iseer - a.iseer),
    standard: PRODUCTS.filter(p => p.tier === "standard" && p.ton === ton).sort((a,b) => b.iseer - a.iseer),
    fixed:    PRODUCTS.filter(p => p.tier === "fixed"    && p.ton === ton).sort((a,b) => b.iseer - a.iseer),
  };
}

// ─── Helper: representative product per tier for comparison ───────
export function getTierReps(ton) {
  const prods = getProducts(ton);
  return {
    premium:  prods.premium[0] || null,
    standard: prods.standard[0] || null,
    fixed:    prods.fixed[0] || null,
  };
}